export default {
      id: "video-event_acceleration-usage",
      viewBox: "0 0 23 23",
      url: __webpack_public_path__ + "img/icons.svg#video-event_acceleration",
      toString: function () {
        return this.url;
      }
    }